// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".myCustomDatePicker .ui-date-picker .input-group .icon {\n  top: calc(45% - 1em/2);\n}\n", ""]);
// Exports
module.exports = exports;
